module.exports = __webpack_public_path__ + "img/yqgz.36ae0efa.png";